import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class OrganChart extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            parentId: this.isNull(props.ParentId) ? this.defaultGuid() : props.ParentId,
            caller: props.Caller,
            data: null,
            loading: true
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/organchart/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/organchart/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            parentId: this.state.parentId,
            workingGroupId: this.state.data.record.workingGroupId,
            positionId: this.state.data.record.positionId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش گره" : "افزودن گره جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <label className="form-label">پست سازمانی</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                defaultValue={this.state.data.record.positionId != this.getDefaultGuid() ? [{ value: this.state.data.record.positionId, label: this.state.data.record.positionTitle }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب پست"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadOrganPositionOptions(inputValue, callback)}
                                                onChange={e => this.state.data.record.positionId = e.value}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <label className="form-label">کارگروه سازمانی</label>
                                        <div className="form-control-wrap">
                                            <SelectAsync
                                                defaultValue={this.state.data.record.workingGroupId != this.getDefaultGuid() ? [{ value: this.state.data.record.workingGroupId, label: this.state.data.record.workingGroupTitle }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب کارگروه"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadOrganWorkingGroupOptions(inputValue, callback, 6)}
                                                onChange={e => this.state.data.record.workingGroupId = e.value}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}